/**
 * Version utility for reading app version from package.json
 * Uses build-time injected APP_VERSION with fallback to package.json
 */

import packageJson from '../../../../../package.json';

export function getAppVersion(suffix?: string): string {
  // APP_VERSION is injected at build time via --define, declared in src/types.d.ts
  const baseVersion = (globalThis as any).APP_VERSION || packageJson.version;
  return suffix ? `${baseVersion}${suffix}` : baseVersion;
}
